import { defineStore } from 'pinia';
import { useSessionStorage } from '@vueuse/core';
import { i18n } from '@/plugins/i18n.js';

const ALLOWED_LOCALES = ['en', 'fr'];
const DEFAULT_LOCALE = 'en';

export const useLanguageStore = defineStore('language', () => {
    const storedLocale = useSessionStorage('user-locale', DEFAULT_LOCALE);
    const locale = i18n.global.locale;

    function sanitizeLocale(value) {
        return ALLOWED_LOCALES.includes(value) ? value : DEFAULT_LOCALE;
    }

    // Initialize locale with a sanitized value
    const initial = sanitizeLocale(storedLocale.value);
    storedLocale.value = initial;
    locale.value = initial;

    function setLocale(newLocale) {
        const next = sanitizeLocale(newLocale);
        locale.value = next;
        storedLocale.value = next;
    }

    return {
        locale: storedLocale,
        setLocale,
        allowedLocales: ALLOWED_LOCALES,
    };
});
